import React from "react"
import { AppText } from "~/ui/app-text"
import TriviaWithStars from "~/images/trivia-with-stars.png"
import pluralize from "pluralize"

enum TriviaGameColors {
  Black = "black",
  Orange = "orange",
  Purple = "purple",
  Lime = "lime",
  Blue = "blue",
}

export const TRIVIA_COLOR_VARIATIONS: Record<TriviaGameColors, { backgroundColor: string }> = {
  [TriviaGameColors.Blue]: {
    backgroundColor: "#0077FF",
  },
  [TriviaGameColors.Orange]: {
    backgroundColor: "#E73A00",
  },
  [TriviaGameColors.Purple]: {
    backgroundColor: "#AA42FF",
  },
  [TriviaGameColors.Lime]: {
    backgroundColor: "#388E54",
  },
  [TriviaGameColors.Black]: {
    backgroundColor: "#000",
  },
}

interface Props {
  color: string | null | undefined
  title: string | null | undefined
  responseCount: number
}

export const MessageAttachmentTrivia: React.FC<Props> = ({
  color: triviaColor,
  title,
  responseCount,
}) => {
  const colorKey = Object.values(TriviaGameColors).includes(triviaColor as TriviaGameColors)
    ? (triviaColor as TriviaGameColors)
    : TriviaGameColors.Blue
  const bgColor = TRIVIA_COLOR_VARIATIONS[colorKey].backgroundColor

  return (
    <div
      className="relative w-full overflow-hidden rounded-2xl border border-neutral-200 p-6"
      style={{ backgroundColor: bgColor }}
    >
      <div className="flex flex-col justify-center gap-2">
        <AppText variant="h3" className="text-center font-bold text-white">
          {title}
        </AppText>
        <img src={TriviaWithStars} className="w-[250px]" />
        <AppText variant="h3" className="text-center uppercase text-white">
          {responseCount > 0 ? pluralize("play", responseCount, true) : "Be the first"}
        </AppText>
      </div>
    </div>
  )
}
